import { gql } from '@apollo/client'

export const GET_SELECT_OPTIONS = gql`
	query SelectOptions( $filter: SelectOptionFilter!) {
		selectOptions(filter: $filter) {
			nodes {
				id
				name
			}
			totalCount
			pageInfo {
				hasPreviousPage
				hasNextPage
				endCursor
				startCursor
			}
		}
	}
`
